// Literal classes only: consuming apps scan folio's source for Tailwind class names.
const lightToneClasses = {
  primary: 'bg-primary/10 text-primary',
  muted: 'bg-muted text-muted-foreground',
  info: 'bg-blue-100 text-blue-700',
  success: 'bg-green-100 text-green-700',
  warning: 'bg-amber-100 text-amber-700',
  destructive: 'bg-red-100 text-red-700',
} as const;

const filledToneClasses = {
  primary: 'bg-primary text-primary-foreground',
  muted: 'bg-muted-foreground text-background',
  info: 'bg-blue-600 text-white',
  success: 'bg-green-600 text-white',
  warning: 'bg-amber-500 text-white',
  destructive: 'bg-destructive text-destructive-foreground',
} as const;

export type Tone = keyof typeof lightToneClasses;

export { filledToneClasses, lightToneClasses };
